import type { GameWithRelations } from "@/types/game";

/**
 * Normalizes `/api/games/search-catalog` JSON into a game array (handles accidental wrappers).
 */
export function parseSearchCatalogResponse(raw: unknown): GameWithRelations[] {
  if (Array.isArray(raw)) {
    return raw as GameWithRelations[];
  }
  if (raw && typeof raw === "object" && "games" in raw) {
    const inner = (raw as { games: unknown }).games;
    if (Array.isArray(inner)) {
      return inner as GameWithRelations[];
    }
  }
  return [];
}
